var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [
            _vm._v(
              " " +
                _vm._s(
                  _vm.existing
                    ? "Edit Automatic Reply"
                    : "Create Automatic Reply"
                ) +
                " "
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.loading
              ? _c("gg-loading", {
                  attrs: {
                    loading: true,
                    type: "list-item"
                  }
                })
              : _c(
                  "v-form",
                  {
                    staticClass: "pt-2",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                        return _vm.save($event)
                      }
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "body-2"
                      },
                      [
                        _vm._v(" Messages sent to "),
                        _c("strong", [_vm._v(_vm._s(_vm.mailbox.email))]),
                        _vm._v(
                          " are answered with this reply. The mailbox still receives them. "
                        )
                      ]
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c("gg-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                dense: "",
                                label: "From",
                                placeholder: "ex. Jane Doe",
                                name: "From",
                                "error-messages": _vm.errors.collect("From")
                              },
                              model: {
                                value: _vm.model.from,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.model, "from", $$v)
                                },
                                expression: "model.from"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c("gg-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                dense: "",
                                label: "Subject",
                                placeholder: "ex. Out of office",
                                name: "Subject",
                                "error-messages": _vm.errors.collect("Subject")
                              },
                              model: {
                                value: _vm.model.subject,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.model, "subject", $$v)
                                },
                                expression: "model.subject"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c("v-textarea", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                dense: "",
                                rows: "5",
                                label: "Message",
                                name: "Message",
                                "error-messages": _vm.errors.collect("Message")
                              },
                              model: {
                                value: _vm.model.body,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.model, "body", $$v)
                                },
                                expression: "model.body"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c("gg-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|integer|min_value:0",
                                  expression: "'required|integer|min_value:0'"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                dense: "",
                                type: "number",
                                min: "0",
                                label: "Reply interval (hours)",
                                hint:
                                  "How long before the same sender gets the reply again.",
                                "persistent-hint": "",
                                name: "Interval",
                                "error-messages": _vm.errors.collect("Interval")
                              },
                              model: {
                                value: _vm.model.interval,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.model, "interval", $$v)
                                },
                                expression: "model.interval"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "py-0",
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c("v-checkbox", {
                              staticClass: "mt-1",
                              attrs: {
                                color: "green",
                                label: "Message is HTML",
                                "hide-details": ""
                              },
                              model: {
                                value: _vm.model.isHtml,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.model, "isHtml", $$v)
                                },
                                expression: "model.isHtml"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.saving,
                  disabled: _vm.loading
                },
                on: {
                  click: _vm.save
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.existing ? "Save" : "Create Automatic Reply") +
                    " "
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }